import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQsPage = () => {
  // Track open category and question
  const [openCategory, setOpenCategory] = useState<number | null>(null);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleCategory = (index: number) => {
    setOpenCategory(openCategory === index ? null : index);
    setOpenFaq(null); // Close any open FAQ when toggling categories
  };
  const toggleFaq = (categoryIndex: number, faqIndex: number) => {
    if (openCategory === categoryIndex) {
      setOpenFaq(openFaq === faqIndex ? null : faqIndex);
    } else {
      setOpenCategory(categoryIndex);
      setOpenFaq(faqIndex);
    }
  };
  const faqCategories = [{
    title: 'Contacting Customer Support',
    faqs: [{
      question: 'How can I get in touch with you?',
      answer: "You can contact our support team by phone on 0800 055 4969 or by email at dronakoirala6@gmail.com. Our team is available Monday to Friday, from 9 am to 5 pm, and on Saturdays from 9 am to 1 pm. We'll get back to any messages received outside of these hours on the next working day."
    }]
  }, {
    title: 'Your Service Plan',
    faqs: [{
      question: 'When does my cover start and end?',
      answer: 'Your coverage begins as soon as your payment is processed. For a 12-month plan, if you buy it on the 15th of July, your protection will last until 23:59 on the 14th of July the following year.'
    }, {
      question: 'How do I get a repair?',
      answer: 'Simply contact us on 0800 055 4969 or email dronakoirala6@gmail.com. We typically schedule engineer appointments within 24 to 48 hours.'
    }, {
      question: "What does 'unlimited repairs' mean?",
      answer: 'You can request an unlimited number of repair visits for all appliances covered under your plan.'
    }, {
      question: "What's included in my plan?",
      answer: 'Your plan covers mechanical and electrical faults on all your registered appliances.'
    }, {
      question: "What's not covered?",
      answer: "Your plan does not cover: Accidental or liquid damage. Appliances that are not registered. Appliances that are older than the specified age limit. Faults that existed before your plan started. Damage caused by misuse, neglect, or tampering. Repairs unrelated to the appliance's normal operation. Damage from floods, fires, or other natural disasters."
    }, {
      question: 'Do you cover the whole of the UK?',
      answer: 'Yes, our services cover England, Scotland, and Wales. However, for some remote postcodes, we recommend you check our availability before you purchase a plan.'
    }, {
      question: "What happens if a repair doesn't fix the fault?",
      answer: 'Contact us straight away. If an issue cannot be resolved after reasonable attempts, you may be eligible for a pro-rated refund or a replacement credit.'
    }]
  }, {
    title: 'Cancellations and Refunds',
    faqs: [{
      question: 'What is your refund policy?',
      answer: 'You can cancel within 14 days of purchase for a full refund, as long as no repair work has started. After 14 days, you may be eligible for a partial refund at our discretion, up to 28 days from the purchase date. No refunds are offered after 28 days.'
    }, {
      question: 'How do I get a refund?',
      answer: 'To request a refund, please contact us by email at dronakoirala6@gmail.com or by phone on 0800 055 4969, and be sure to have your order number ready. Refunds are processed to your original payment method within 7 to 10 working days.'
    }]
  }, {
    title: 'Payment & Disputes',
    faqs: [{
      question: 'What payment methods do you accept?',
      answer: 'We accept payments via credit and debit cards (Visa, Mastercard), Apple Pay, Google Pay, BACS, Direct Debit, and cheques by post.'
    }, {
      question: 'What if I have a payment or service dispute?',
      answer: 'Please contact us at dronakoirala6@gmail.com or on 0800 055 4969 before raising a dispute with your bank. We are committed to resolving issues quickly and fairly. Initiating a chargeback without prior contact may delay your refund.'
    }]
  }];
  return <div className="container mx-auto px-4 py-12" data-id="element-217">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-218">
        Frequently Asked Questions
      </h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-219">
        <div className="space-y-8" data-id="element-220">
          {faqCategories.map((category, categoryIndex) => <div key={categoryIndex} className="border-b border-gray-200 pb-6 last:border-b-0 last:pb-0" data-id="element-221">
              <button className="flex justify-between items-center w-full text-left font-bold text-[#1A2B4C] py-3 text-xl" onClick={() => toggleCategory(categoryIndex)} data-id="element-222">
                <span data-id="element-223">{category.title}</span>
                {openCategory === categoryIndex ? <ChevronUpIcon size={24} className="text-[#1FC5A8]" data-id="element-224" /> : <ChevronDownIcon size={24} className="text-[#1FC5A8]" data-id="element-225" />}
              </button>
              {openCategory === categoryIndex && <div className="mt-4 space-y-4" data-id="element-226">
                  {category.faqs.map((faq, faqIndex) => <div key={faqIndex} className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0" data-id="element-227">
                      <button className="flex justify-between items-center w-full text-left font-medium text-[#1A2B4C] py-2 pl-4" onClick={() => toggleFaq(categoryIndex, faqIndex)} data-id="element-228">
                        <span data-id="element-229">{faq.question}</span>
                        {openCategory === categoryIndex && openFaq === faqIndex ? <ChevronUpIcon size={18} className="text-[#1FC5A8]" data-id="element-230" /> : <ChevronDownIcon size={18} className="text-[#1FC5A8]" data-id="element-231" />}
                      </button>
                      {openCategory === categoryIndex && openFaq === faqIndex && <div className="mt-2 text-gray-600 pl-4 pr-2" data-id="element-232">
                            {faq.answer}
                          </div>}
                    </div>)}
                </div>}
            </div>)}
        </div>
      </div>
    </div>;
};
export default FAQsPage;